import { NavLink } from "react-router-dom";
import "./header.scss";
import logo from "./ZaimOnline_Logo.svg";
import logoMobile from "./logo-mobile.svg";
import { useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";

const Header = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isSearchVisible, setSearchVisible] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const toggleSearch = () => {
    setSearchVisible((prev) => !prev);
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header__wrapper">
          <div className="header__wrapper-top">
            <picture>
              <source srcSet={logoMobile} media="(max-width: 992px)" />
              <img src={logo} alt="logo" />
            </picture>
            <div className="header__wrapper-descr">
              <h1>Выгодные займы в одном месте!</h1>
            </div>
            <button className="burger" onClick={toggleMenu}>
              <RxHamburgerMenu />
            </button>
          </div>

          <div className="header__divider"></div>
          <div className={`header__wrapper-bottom ${isMenuOpen ? "open" : ""}`}>
            <NavLink to="/">Займы</NavLink>
            {/* <NavLink to="/loans">Кредиты</NavLink> */}
            {/* <NavLink to="/credit-card">Кредитные карты</NavLink> */}
            {/* <NavLink to="/debit-card" onClick={handleLinkClick}>
              Дебетовые карты
            </NavLink> */}
            <NavLink to="/cookies" onClick={handleLinkClick}>
              Cookies
            </NavLink>
            <NavLink to="/dataProtection" onClick={handleLinkClick}>
              Защита данных
            </NavLink>
            <NavLink to="/usage" onClick={handleLinkClick}>
              Использование
            </NavLink>
            <NavLink to="/contacts" onClick={handleLinkClick}>
              Контакты
            </NavLink>
            <NavLink to="/policy" onClick={handleLinkClick}>
              Политика конфиденциальности
            </NavLink>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
